module.exports = __webpack_public_path__ + "img/Norma.305886d9.png";